
    <button
      class="btn {{ variant$ | async }} fieldmagic-btn {{ customClass }}"
      [ngClass]="klass"
      [disabled]="isInProgress || disabled || denied"
      [class.fieldmagic-btn-lg]="size == 'lg'"
      [class.btn-block]="size == 'full'"
      [class.fieldmagic-btn-icon]="purpose == 'icon'"
      [class.fieldmagic-btn-icon]="purpose == 'delete-icon'"
      [class.fieldmagic-btn-icon]="purpose == 'add-line'"
      [class.fieldmagic-btn-showcase]="showcase"
      [class.fieldmagic-btn-list-action]="purpose == 'list-action'"
      [class.fieldmagic-btn-list-link]="variant == 'list-link'"
      [matTooltip]="'forbidden_action_error' | translate | when: denied:{
        otherwise: tooltip | translate
      }"
      [style.background]="color"
      [style.color]="color | bg_text_color"
      [style.border-color]="color"
    >
      <fieldmagic-icon
        *ngIf="(icon | filled) || isInProgress; else content;"
        [icon]="icon || 'spinner'"
        [spin]="isInProgress"
        [size]="iconSize"
        [position]="iconPosition"
      >
        <ng-container [ngTemplateOutlet]="content"></ng-container>
      </fieldmagic-icon>
      <ng-template #content>
        <ng-content *ngIf="label | blank; else asLabel"></ng-content>
      </ng-template>
      <ng-template #asLabel>
        <span *ngIf="hasLabel">{{ label | translate }}</span>
      </ng-template>
    </button>
  